import React, { Component, useEffect, useRef, useState, useSyncExternalStore } from "react";
import { Modal, Button } from "react-bootstrap";
import { getAlert } from "../../../services/appAlerts";
import useControls from "../../../app/hooks/useControls";
import useForm from "../../../app/hooks/useForm";
import { getCurrentUser } from "../../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  SendAddedEmailMessage,
  SendDraftEmailMessage,
  SendEmailMessage, addNewEmail, addNewEmailMessage, emailMessageAdded, emailMessageSent,
  getEmailAddedStatus, getEmailUpdatedStatus, getMailDocUploadSasRes, getSentEmailStatus, updateEmailMessage
} from "../../../app/store/users";
import { uploadFileToBlob } from "../../../services/blobUploadService";

const SendEmail = (props) => {

  const { showHide, handleModalShowHide, selectedEmail,
    selectedObj, viewType, selectedMailObj, handleUpdateModalShowHide, msgType } = props;

  const [saveBtnType, setSaveBtnType] = useState("");
  const [saveBtnProcess, setSaveBtnProcess] = useState(false);
  const [draftBtnProcess, setDraftBtnProcess] = useState(false);
  const [documents, setDocuments] = useState([]);

  const emailAddedStatusSelector = useSelector(getEmailAddedStatus);
  const sentEmailStatusSelector = useSelector(getSentEmailStatus);
  const emailUpdatedStatusSelector = useSelector(getEmailUpdatedStatus);
  const mailDocUploadSasResSelector = useSelector(getMailDocUploadSasRes);

  const currentUser = getCurrentUser();

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  useEffect(() => {
    const dt = {};
    if (selectedObj) {
      //dt["emailFrom"] = "anand@ipcs.net";
      dt["emailTo"] = selectedObj.performeremail;
      dt["performerId"] = selectedObj.performerid;
      dt["ciid"] = selectedObj.ciid;
      dt["wiid"] = selectedObj.wiid;
      dt["iiid"] = selectedObj.iiid;
      dt["emails"] = [{ key: selectedObj.performerid, value: selectedObj.performeremail }];
    }

    if (selectedEmail?.length > 0) {
      dt["emailTo"] = selectedEmail.map((x) => x.value).join(", ");
      dt["emails"] = selectedEmail;
    }

    dt["subject"] = "";
    dt["mailBody"] = "";
    dt["addedBy"] = currentUser.id;

    setStateData(dt);

  }, [selectedObj]);

  useEffect(() => {
    const dt = {};
    if (selectedMailObj) {
      dt["emailTo"] = selectedMailObj.emailTo;
      dt["id"] = selectedMailObj.id;
      dt["subject"] = selectedMailObj.subject;
      dt["mailBody"] = selectedMailObj.mailBody;
      setStateData(dt);
    }
  }, [selectedMailObj]);


  const schema = {};

  useEffect(() => {
    if (emailAddedStatusSelector) {
      setSaveBtnProcess(false);
      setDraftBtnProcess(false);
      // if (saveBtnType === "send") {
      //   getAlert("Sent Successfully", "", "success");
      // }
      if (saveBtnType === "draft") {
        getAlert("Saved Successfully", "", "success");
      }

      handleModalShowHide("save");
      dispatch(emailMessageAdded(false));
      setStateData({})
      setDocuments([])
    }

  }, [emailAddedStatusSelector]);

  useEffect(() => {
    if (emailUpdatedStatusSelector) {
      getAlert("Updated Successfully", "", "success");
      setSaveBtnProcess(false);
      setDraftBtnProcess(false);
      if (handleUpdateModalShowHide)
        handleUpdateModalShowHide();
    }
  }, [emailUpdatedStatusSelector])

  const doSubmit = (btnType) => {
    setSaveBtnType(btnType);

    // const frmData = new FormData();

    // // Append simple fields
    // if (selectedEmail?.length > 0) {
    //   frmData.append("emailTo", selectedEmail.map((x) => x.value).join(", "));
    //   frmData.append("emails", JSON.stringify(selectedEmail)); // API should expect string Emails
    // }

    // frmData.append("subject", stateData.subject || "");
    // frmData.append("mailBody", stateData.mailBody || "");
    // frmData.append("addedBy", stateData.addedBy?.toString() || "0");

    // // sendStatus must be "true"/"false" as string (ASP.NET binder handles it)
    // frmData.append("sendStatus", btnType === "send" ? "true" : "false");

    // // Append files (all under the same key)
    // documents.forEach((file) => {
    //   frmData.append("files", file.file); // 👈 not files[0], files[1]
    // });

    const payload = {
      emailTo: selectedEmail?.map(x => x.value).join(", ") || "",
      emails: JSON.stringify(selectedEmail || []),
      subject: stateData.subject || "",
      emailFrom: stateData.emailFrom || "",
      mailBody: stateData.mailBody || "",
      addedBy: Number(stateData.addedBy) || 0,
      ciid: Number(stateData.ciid) || 0,
      wiid: Number(stateData.wiid) || 0,
      iiid: Number(stateData.iiid) || 0,
      sendStatus: btnType === "send",
      files: documents?.map(x => ({
        name: x.name,
        type: x.type,
        size: x.size
      })) || []
    };

    if (btnType === "send") {
      setSaveBtnProcess(true);
    } else if (btnType === "draft") {
      setDraftBtnProcess(true);
    }

    if (btnType === "Update") {
      dispatch(updateEmailMessage(payload));
    } else {
      dispatch(addNewEmailMessage(payload));
    }
  };

  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (mailDocUploadSasResSelector?.sasUrls?.length > 0) {
        try {
          getAlert("Sent Successfully", "", "success");
          await Promise.all(
            documents.map((file, key) =>
              uploadFileToBlob(
                file.file,
                mailDocUploadSasResSelector.sasUrls[key]?.uploadUrl,
                (progress) => {
                  if (progress === 100 && saveBtnType === "send") {
                    //const historyId = mailDocUploadSasResSelector.historyIds[key];
                    //dispatch(SendAddedEmailMessage(historyId));
                  }
                }
              )
            )
          );

          // Runs only after ALL uploads finish
          //handleModalShowHide("save");
          if (saveBtnType === "send") {
            mailDocUploadSasResSelector.historyIds.forEach(historyId => {
              dispatch(SendAddedEmailMessage(historyId));
            });
          }
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [mailDocUploadSasResSelector]);


  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      };
      docs.push(doc);
    }

    setDocuments(docs);
    setStateData((prevState) => ({
      ...prevState,
      documents: docs
    }));
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const modalClose = () => {
    setStateData({})
    setDocuments([])
    handleModalShowHide("")
  }

  const { validate, handleChange, stateData, setStateData, stateErrors, setStateErrors, handleSubmit } = useForm(schema, doSubmit);

  const { renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  return (
    <Modal show={showHide} size="xl">
      <Modal.Header closeButton onHide={() => modalClose()}>
        <Modal.Title>
          {selectedEmail?.length > 0
            ? "Send Bulk Email"
            : "Send Email"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          {/* <div className="col-md-12">
            {renderInput("emailFrom", "From Email")}
          </div> */}
          <div className="col-md-12">
            {selectedEmail?.length > 0
              ? renderTextArea(
                "emailTo",
                `To Email (Total Count: "${selectedEmail.length})`
              )
              : renderInput("emailTo", "To Email")}
          </div>

          <div className="col-md-12">
            {renderInput("subject", "Subject")}
          </div>
          <div className="col-md-12">
            {renderTextArea("mailBody", "Message Body")}
          </div>
          <div className="col-md-12">
            {/* Add Button */}
            <Button
              variant="outline-dark"
              size="sm"
              onClick={() => {
                fileInputRef.current.click();
              }}
            >
              <i className="fa fa-paperclip mr-2" aria-hidden="true"></i>
              Add
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={onFileChange}
              multiple
              style={{ position: "absolute", top: "-9999px" }}
            />

            {documents.length > 0 && (
              <div className="file-preview" style={{ marginLeft: " 0px !important" }}>
                {documents.map((file, index) => (
                  <div key={index} className="file-preview-item">
                    <span>{file.name}</span>
                    <span
                      className="file-size"
                      style={{
                        backgroundColor: "#f0f0f0",
                        marginLeft: "10px",
                        padding: "2px 5px",
                        borderRadius: "5px",
                      }}
                    >
                      {file.size} KB
                    </span>
                    <button
                      className="btn btn-sm btn-link"
                      onClick={() => handleFileRemove(file)}
                    >
                      <i className="fa fa-times text-red" aria-hidden="true"></i>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <button className="btn btn-sm btn-outline-default" onClick={() => modalClose()}>
          <i class="fa fa-times" aria-hidden="true"></i> Close
        </button> */}

        {viewType === "edit" &&
          <button className="btn btn-sm btn-outline-default" disabled={saveBtnProcess} onClick={() => handleSubmit("Update")}>
            {saveBtnProcess ? <i class="fa fa-circle-o-notch fa-spin"></i> : <i class="fa fa-pencil" aria-hidden="true"></i>} Update
          </button>
        }
        {viewType === "add" && <>
          <button className="btn btn-sm btn-outline-default" disabled={draftBtnProcess} onClick={() => handleSubmit("draft")}>
            {draftBtnProcess ? <i class="fa fa-circle-o-notch fa-spin"></i> : <i class="fa fa-check" aria-hidden="true"></i>} Save as Draft
          </button>
          <button className="btn btn-sm btn-outline-default" disabled={saveBtnProcess} onClick={() => handleSubmit("send")}>
            {saveBtnProcess ? <i class="fa fa-circle-o-notch fa-spin"></i> : <i class="fa fa-paper-plane" aria-hidden="true"></i>} Send
          </button> </>
        }
      </Modal.Footer>
    </Modal>
  );
}

export default SendEmail;
